<template>
  <gj-modal
    :visible.sync="modalVisible"
    size="full-middle"
    :footer="false"
    v-on="$listeners"
    class="table-modal"
    :contentStyle="{ height: '100%', display: 'flex', 'flex-direction': 'column' }"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>
      <span>关联产品</span>
    </template>
    <template #content>
      <div>
        <el-row type="flex" justify="space-between">
          <el-col :span="14">
            <gj-search-input
              style="width: 250px; margin-bottom: 12px"
              placeholder="请输入产品名称或SKU"
              v-model="keyword"
            >
            </gj-search-input>
            <gj-button type="primary" style="height: 32px; margin-left: 10px" @click="search">
              查询
            </gj-button>
          </el-col>
          <el-col :span="6">
            <span>找不到需要关联的SKU？</span
            ><gj-button type="text" @click="generateSKU()">快速生成SKU</gj-button>
          </el-col>
        </el-row>
      </div>
      <div style="flex: 1; overflow: auto">
        <gj-table
          name="relate-product"
          adaptParent
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          :size="'has-picture'"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :offsetHeight="10"
        >
          <template v-slot:productName="{ row }">
            <gj-tooltip :text-line="1" :content="row.productName">
              {{ row.productName || '-' }}
            </gj-tooltip>
            <el-row>
              <gj-tooltip :content="row.sku">
                {{ row.sku | defaultShow }}
              </gj-tooltip>
              <gj-copy-icon :content="row.sku"></gj-copy-icon>
            </el-row>
          </template>
          <template v-slot:op="{ row }">
            <gj-button type="text" @click="relateProduct(row)">关联</gj-button>
          </template>
        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, queryMixin } from '@/minxins';
import { batchRelateProduct, getListingRelatePage, relateOtherProduct, otherLinkProduct } from '@/api/sale';
import singleModal from './components/single-modal';
import multiModal from './components/multi-modal';

export default {
  name: 'app-relate-product-modal',
  mixins: [modalMixIn, queryMixin],
  props: {
    ids:{
      default: ()=> {
        return []
      }
    } ,
    newCompatibilityApi:{
      type:Boolean,
      default:false
    },
    id: [String, Number],
    marketId: [String, Number],
    msku: String,
    commonQueryDTOS:null,
    mode: {
      type: String,
      default: 'single',
      validator(val) {
        return ['batch', 'single'].includes(val);
      },
    },
  },
  data() {
    return {
      tableData: [],
      columns: [
        { id: 'picture', header: '图片', field: 'picture:imageUrl', width: '50px' },
        { id: 'productName', header: '产品名称/SKU', field: 'slot:productName', minWidth: '300px' },
        { id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '120px' },
        { id: 'brandName', header: '品牌', field: 'brandName', minWidth: '120px' },
        { id: 'op', header: '操作', field: 'slot:op', width: '80px', notCustomColumn: true },
      ],
      childModalVisible: {
        relateProductOption: false,
      },
      keyword: null,
      search: this._.debounce(this.$gjQuery, 500),
    };
  },
  methods: {
    generateSKU() {
      const vm = this
      const component = {
        single: singleModal,
        batch: multiModal,
      };
      const modal = this.$gjCreate(component[this.mode], {
        props: {
          ids: this.ids,
          id: this.id,
          marketId:this.marketId,
          msku: this.msku,
          newCompatibilityApi:this.newCompatibilityApi,
          commonQueryDTOS:this.commonQueryDTOS
        },
        on: {
          after() {
            vm.$emit('after');
            modal.$gjDestroy();
          },
        },
      });
    },
    $gjQuery() {
      this.loading = true;
      getListingRelatePage({
        model: {
          fuzzyParam: this.keyword,
        },
        ...this.queryPagination,
        ...this.querySort,
      })
        .then((data) => {
          this.tableData = data.records;
          this.pagination = this.getPagination(data);
        })
        .complete(() => (this.loading = false));
    },
    relateProduct(row) {
      const vm = this;
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '关联确认',
          content: `确定要关联产品【${row.sku}】？`,
        },
        on: {
          cancel() {
            modal.$gjDestroy();
          },
          confirm() {
            modal.confirmLoading = true;

             let promise = null
             if (vm.newCompatibilityApi) {
                promise = otherLinkProduct(
                  {
                    marketId: vm.marketId,
                    msku:vm.msku,
                    sku:row.sku
                  }
                )
             }else{
               if (vm.mode==='batch') {
               promise = batchRelateProduct({
                  ids: vm.ids,
                  commonQueryDTOS:vm.commonQueryDTOS,
                  sku: row.sku,
                });
             }else{
               promise = relateOtherProduct({
                  id: vm.id,
                  commonQueryDTOS:vm.commonQueryDTOS,
                  sku: row.sku,
                });
             }
             }
            promise
              .then(() => {
                vm.$gjMessage.success('操作成功');
                vm.$emit('after');
                modal.$gjDestroy();
              })
              .complete(() => (modal.confirmLoading = false));
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .vxe-table--body-wrapper {
  overflow-x: hidden !important;
}
/deep/ .el-dialog__body {
  padding-top: 12px;
}
</style>
